/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { MarginPositionFragmentDoc } from "./fragments.service.graphql-gen";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetMarginPositionQueryVariables = Types.Exact<{
	input: Types.MarginAssetInput;
	period?: Types.InputMaybe<Types.TimePeriod>;
}>;

export type GetMarginPositionQuery = {
	__typename?: "Query";
	portfolio?: {
		__typename?: "Portfolio";
		marginPosition?: {
			__typename?: "MarginPosition";
			id: string;
			assetPosition: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
			fiatPosition: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
			leverage: { value: string; precision: number };
			leverageDirection: Types.LeverageDirection;
			performancePercentage: { value: string; precision: number };
			performance: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
			liquidationPrice: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
			liquidationThresholdPercentage: { value: string; precision: number };
			availableLimitOrderExitOrderTypes?: Array<Types.MarginLimitOrderExitOrderType> | null;
			initialInvestment?: {
				precision: number;
				unit_symbol: string;
				unit_symbol_type: string;
				value: string;
			} | null;
			borrowedFunds?: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string } | null;
			averageOpeningPrice?: {
				precision: number;
				unit_symbol: string;
				unit_symbol_type: string;
				value: string;
			} | null;
			limitOrders?: Array<{
				__typename?: "MarginLimitOrder";
				id: string;
				pid: string;
				assetAmount: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
				exitOrderType: Types.MarginLimitOrderExitOrderType;
				targetPrice: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
				targetPriceChangePercentage: { value: string; precision: number };
			}> | null;
			marginLevel: {
				__typename?: "MarginLevel";
				current: { value: string; precision: number };
				healthIndicator: Types.MarginHealthIndicator;
				maximum: { value: string; precision: number };
				minimum: { value: string; precision: number };
				highHealthThreshold: { value: string; precision: number };
				lowHealthThreshold: { value: string; precision: number };
			};
			asset:
				| {
						__typename?: "CommodityAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "CryptoAsset";
						marketCap?: { value: string; precision: number } | null;
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "EquityComplexEtfAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "EquityEtcAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "EquityEtfAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "EquityRightAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "EquityStockAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "EtfAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "GenericAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "IndexAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "LeverageAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "MetalAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "SecurityTokenAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "StockAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  };
		} | null;
	} | null;
};

export const GetMarginPositionDocument = gql`
	query GetMarginPosition($input: MarginAssetInput!, $period: TimePeriod = DAY) {
		portfolio {
			marginPosition(input: $input) {
				...MarginPosition
			}
		}
	}
	${MarginPositionFragmentDoc}
`;

@Injectable({
	providedIn: "root"
})
export class GetMarginPositionGQLService extends Apollo.Query<GetMarginPositionQuery, GetMarginPositionQueryVariables> {
	document = GetMarginPositionDocument;
	client = "bff";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
